import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { clientData } from '../../../Data';

const { Text } = Typography
const SingleViewClient = () => {
    let { clientId } = useParams()
    const navigate = useNavigate() 
    const [loading, setLoading] = useState(true)
    const singleData = clientData?.find((fin)=> fin.id === clientId)

    console.log('Data',singleData)
    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Full Name</Text>
                <Text>
                    {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)}{' '}
                    {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Email</Text>
                <Text>{singleData?.email}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Contact Number</Text>
                <Text>{singleData?.phoneNo}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Age</Text>
                <Text>{singleData?.age}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Worker Experience</Text>
                <Text>{singleData?.expwork}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Need Services</Text>
                <Flex gap={5} wrap>
                    {
                        singleData?.services?.map((data)=>
                            <Text className='badge-cs brand-bg text-white fs-12'>
                                {data}
                            </Text>
                        )
                    }
                </Flex>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Registeration Date</Text>
                <Text>{singleData?.expwork}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Project Details</Text>
                <Text>
                    {singleData?.description}
                </Text>
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                      title: <Text className='cursor text-gray' onClick={()=>navigate('/clients')}>Client</Text>,
                    },
                    {
                      title: <Text className='fw-500'>
                        {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)}{' '}
                        {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                      </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/clients')}>
                                <ArrowLeftOutlined />
                            </Button>
                            <Text className='fw-500'>
                                {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)}{' '}
                                {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                            </Text>
                            {
                                singleData?.status === 1 ? (
                                    <Text className='badge-cs active'>Active</Text>
                                ) : (
                                    <Text className='badge-cs inactive'>Inactive</Text>
                                )
                            }
                        </Space>
                    </Col>  
                    <Col span={24}>
                        <Table 
                            size='large'
                            columns={columns} 
                            dataSource={data} 
                            scroll={{x: 1000}}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            // loading={
                            //     {
                            //         ...TableLoader,
                            //         spinning: loading
                            //     }
                            // }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewClient }
